import { create } from 'zustand'

const STORAGE_KEY = 'counselpro:updates:last-seen-at'

const readLastSeen = () => {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

interface UpdatesState {
  lastSeenAt: string | null
  latestPublishedAt: string | null
  markSeen: (at?: string | null) => void
  noteLatestPublishedAt: (at: string | null) => void
}

export const useUpdatesStore = create<UpdatesState>((set, get) => ({
  lastSeenAt: readLastSeen(),
  latestPublishedAt: null,
  markSeen: (at) => {
    const seenAt = at ?? get().latestPublishedAt ?? new Date().toISOString()
    try {
      localStorage.setItem(STORAGE_KEY, seenAt)
    } catch {
      // ignore write failures (private mode / disabled storage)
    }
    set({ lastSeenAt: seenAt })
  },
  noteLatestPublishedAt: (at) => set({ latestPublishedAt: at }),
}))
